import { render, staticRenderFns } from "./NodeUpdateList.vue?vue&type=template&id=23657ab3"
import script from "./NodeUpdateList.vue?vue&type=script&lang=js"
export * from "./NodeUpdateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports